<template>
    <div
        v-if="!showUploadBlock"
        class="max-w-full"
        @drop.prevent
        @dragover.prevent
    >
        <DropdownFileMiniInput
            v-model:uploadedFiles="uploadedFiles"
            :title="title"
            :fileSizeText="fileSizeText"
        />

        <FileList
            v-model:items="uploadedFiles"
            :truncateLength="truncateLength"
            :maxSize="maxSize"
        />
    </div>

    <SuccessBlock v-else />
</template>

<script setup>
import { computed } from 'vue'

import DropdownFileMiniInput from '@/components/inputs/DropdownFileMiniInput.vue'
import FileList from '@/components/lists/FileList.vue'
import SuccessBlock from '@/components/successBlock/SuccessBlock.vue'

const props = defineProps({
    files: {
        type: Array,
        default: () => [],
    },
    truncateLength: {
        type: Number,
        default: 50,
    },
    showUploadBlock: {
        type: Boolean,
        default: false,
    },
    maxSize: {
        type: Number,
        default: null,
    },
    fileSizeText: {
        type: String,
        default: 'Maximum file size 8MB',
    },
    title: {
        type: String,
        default: 'Select File or Drag & Drop',
    },
})

const emits = defineEmits(['update:files'])

const uploadedFiles = computed({
    get() {
        return props.files
    },
    set(data) {
        emits('update:files', data)
    },
})
</script>
